import React from "react";
import TablaCanalRetail from "js/components/TablaCanalRetail";

function CanalRetail(props) {
  return <TablaCanalRetail />;
}

export default CanalRetail;
